import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import CurrencyConverter from "../utils/CurrencyConverter";
import Switch from "../Switch";
import {
  Card,
  CardText,
  CardTitle,
  Col,
  Row,
  Spinner,
  Button,
  Alert,
} from "reactstrap";
import Layout, { Main } from "../Layout";
import styled from "styled-components";

const CelebrityInfosWrapper = styled.div`
  padding-top: 5px;
  position: relative;
  height: 100px;
  background-color: ${({ theme }) => theme.card};
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
`;

const Image = styled.img`
  position: absolute;
  left: calc(100% / 2 - 60px);
  top: 25%;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: solid 2px white;
`;

export const Price = styled.div`
  color: ${({ theme }) => theme.textPrimary};
`;

const Celebrity = ({ celebrities, removeOrderData }) => {
  removeOrderData();
  const location = useLocation();
  const [celebrity, setCelebrity] = useState();
  const navigate = useNavigate();
  const [isEuro, setIsEuro] = useState(
    location.state?.currency === "euro"
      ? true
      : location.state?.currency !== "cfa"
  );

  const capitalize = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  const { id } = useParams();

  const handleOrder = (e, product) => {
    e.preventDefault();
    navigate(`/shop/${celebrity.id}/booking`, {
      state: {
        product: product,
        celebrity: celebrity,
        currency: isEuro ? "euro" : "cfa",
      },
    });
  };

  useEffect(() => {
    const foundCelebrity = celebrities.find((c) => String(c.id) === String(id));

    if (foundCelebrity) {
      setCelebrity(foundCelebrity);
    } else {
      navigate("/");
    }
  }, [id, celebrities, navigate]);

  if (!celebrity) {
    return (
      <Main>
        <Spinner color={"danger"} />;
      </Main>
    );
  }

  return (
    <Layout
      celebrities={celebrities}
      backPath={{
        pathname: `/shop/categories/${celebrity.category.slug}`,
        state: { currency: isEuro ? "euro" : "cfa" },
      }}
    >
      <Main className={"my-3 my-md-3"}>
        <Row>
          <Col className={"mx-auto"}>
            <CelebrityInfosWrapper>
              {celebrity.facebook && (
                <Link
                  className={"m-1"}
                  to={celebrity.facebook}
                  title={"facebook"}
                >
                  <i className="fa-brands fa-facebook fs-4" />
                </Link>
              )}
              {celebrity.tiktok && (
                <Link className={"m-1"} to={celebrity.tiktok} title={"tiktok"}>
                  <i className="fa-brands fa-tiktok fs-5" />
                </Link>
              )}
              {celebrity.instagram && (
                <Link
                  to={celebrity.instagram}
                  className={"m-1"}
                  title={"instagram"}
                >
                  <i className="fa-brands fa-square-instagram fs-4" />
                </Link>
              )}
              {celebrity.twitter && (
                <Link
                  className={"m-1"}
                  to={celebrity.twitter}
                  title={"twitter"}
                >
                  <i className="fa-brands fa-square-x-twitter fs-4" />
                </Link>
              )}
              {celebrity.linkedin && (
                <Link
                  className={"m-1"}
                  to={celebrity.linkedin}
                  title={"linkedin"}
                >
                  <i className="fa-brands fa-linkedin fs-4" />
                </Link>
              )}
              <Image
                src={celebrity.avatar}
                title={`photo de ${celebrity.givenName} ${celebrity.familyName}`}
                alt={`photo de ${celebrity.givenName} ${celebrity.familyName}`}
                className={"object-fit-cover "}
              />
            </CelebrityInfosWrapper>
          </Col>
        </Row>
        <Row className={"mt-2"}>
          <Col>
            <Switch
              state={isEuro}
              setState={setIsEuro}
              trueLabel={"EURO"}
              falseLabel={"CFA"}
            />
          </Col>
        </Row>
        <Row className={"mt-2 text-center"}>
          <Col>
            <div className={"fw-bold"}>{`${capitalize(
              celebrity.givenName
            )} ${celebrity.familyName.toUpperCase()}`}</div>
            <div className={"fw-medium"}>{capitalize(celebrity.title)}</div>
          </Col>
        </Row>
        <Row>
          <Col sm={6} className={"mx-auto"}>
            {celebrity.description}
          </Col>
        </Row>
        {celebrity.available === "yes" ? (
          <Row className={"mt-3 gap-3 gap-md-0"}>
            {celebrity.products.length > 0 &&
              celebrity.products.map((product, index) => (
                <Col
                  key={index}
                  sm={
                    celebrity.products.length > 1
                      ? 12 / celebrity.products.length
                      : 3
                  }
                >
                  <Card className={"h-100 d-flex justify-content-between"} body>
                    <CardTitle tag="h6" className={"fw-bold"}>
                      {capitalize(product.category.name)}{" "}
                      <small className={" fw-normal"}>
                        {product.category.slug.toLowerCase() ===
                          "dedicace-musicale" &&
                          `(${product.quantity} restant(s))`}
                      </small>
                    </CardTitle>
                    <CardText>
                      {product.category.slug.toLowerCase() !==
                      "dedicace-musicale" ? (
                        <p>
                          Livré en :{" "}
                          <span className={"fw-bold"}>
                            {celebrity.delay} heures
                          </span>
                        </p>
                      ) : (
                        <p>
                          Date indicative de sortie de la chanson :{" "}
                          <span className={"fw-bold"}>
                            {new Date(product.launchDate).toLocaleDateString()}
                          </span>
                        </p>
                      )}
                    </CardText>
                    <div
                      className={"d-flex justify-content-center flex-column"}
                    >
                      <Price className={"fw-bold text-center fs-6 mb-3"}>
                        {CurrencyConverter(
                          product.price,
                          product.currency,
                          isEuro ? "euro" : "cfa"
                        )}
                      </Price>
                      <Button
                        className={"fw-bold"}
                        color={"primary"}
                        onClick={(e) => handleOrder(e, product)}
                      >
                        Commander
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))}
          </Row>
        ) : (
          <Row className={"mt-3"}>
            <Col sm={6} className={"mx-auto"}>
              <Alert color={"info"} className={"fw-bold"}>
                Votre célébrité est momentanément indisponible.
              </Alert>
            </Col>
          </Row>
        )}
      </Main>
    </Layout>
  );
};

export default Celebrity;
